import { type FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import CloseIcon from '@atlaskit/icon/core/close';
import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import {
  useBoardId,
  useEnterpriseId,
  useWorkspaceId,
} from '@trello/id-context';
import { Button } from '@trello/nachos/button';

import type { OnboardingScreen } from './SplitScreenOnboarding';

import styles from './CloseButton.less';

interface CloseButtonProps {
  onCloseButtonClick: () => void;
  screen: OnboardingScreen;
}

export const CloseButton: FunctionComponent<CloseButtonProps> = ({
  onCloseButtonClick,
  screen,
}) => {
  const boardId = useBoardId();
  const workspaceId = useWorkspaceId();
  const enterpriseId = useEnterpriseId();

  const onClick = () => {
    Analytics.sendClickedButtonEvent({
      buttonName:
        screen === 'end' ? 'closeOnboardingButton' : 'closeVideoScreenButton',
      source:
        screen === 'end'
          ? 'splitScreenOnboardingCarouselScreen'
          : 'splitScreenOnboardingVideoScreen',
      containers: formatContainers({ boardId, workspaceId, enterpriseId }),
    });

    onCloseButtonClick();
  };
  return (
    <div className={styles.container}>
      <Button
        onClick={onClick}
        iconAfter={<CloseIcon label="Close" color={'currentColor'} />}
        className={styles.button}
      >
        <FormattedMessage
          id="templates.split_screen.onboarding.close"
          defaultMessage="Close"
          description="Close button"
        />
      </Button>
    </div>
  );
};
